import { RadioButton, RadioGroup } from '@statsbomb/kitbag-components';
import {
  usePlaylistCurrentlySelected,
  useVideoCanPlay,
} from '@statsbomb/video-client-js';
import { useAtomValue } from 'jotai';
import React from 'react';
import { useIntl } from 'react-intl';
import { videosRequiringAlignmentVerificationAtom } from '../../../atoms/offsetAlignment';
import useVideosRequiringOffsetAlignmentVerification from '../../../hooks/offsetAlignment';
import useAlignmentStatus from '../../../hooks/offsetAlignmentStatus';

const ALIGNED_RADIO_BUTTON_VALUE = '0';
const MISALIGNED_RADIO_BUTTON_VALUE = '1';

export function AlignmentVerificationSelection() {
  const intl = useIntl();

  const videosRequiringAlignmentVerification = useAtomValue(
    videosRequiringAlignmentVerificationAtom,
  );

  const canPlay = useVideoCanPlay();
  const { calculateIsAligned } = useAlignmentStatus();
  const [currentlyPlayingFromServer] = usePlaylistCurrentlySelected();
  const { updateAlignmentStatus } =
    useVideosRequiringOffsetAlignmentVerification();

  const currentlyPlayingFromLocalStateWithLatestOverrides =
    videosRequiringAlignmentVerification?.find(
      (video) => video.id === currentlyPlayingFromServer?.id,
    );
  const isAligned = calculateIsAligned(
    currentlyPlayingFromLocalStateWithLatestOverrides,
    currentlyPlayingFromServer,
  );

  const videoReference =
    currentlyPlayingFromServer?.videoClipReference?.videoReference;

  const updateStatus = (event) =>
    updateAlignmentStatus({
      id: currentlyPlayingFromServer.id,
      newStatus: event.target.value === ALIGNED_RADIO_BUTTON_VALUE,
      videoReference,
    });

  const disabled = !canPlay || !currentlyPlayingFromServer;

  return (
    <RadioGroup
      alignment="horizontal"
      groupId="radio-group-alignment"
      groupTitle={intl.formatMessage({
        defaultMessage: 'Is the event aligned with the video',
        id: '07e83',
      })}
      size="regular"
    >
      <RadioButton
        checked={!!isAligned}
        disabled={disabled}
        id="radio-aligned-yes"
        label={intl.formatMessage({
          defaultMessage: 'Yes',
          id: '93cba',
        })}
        onChange={updateStatus}
        size="regular"
        value={ALIGNED_RADIO_BUTTON_VALUE}
      />
      <RadioButton
        checked={isAligned === false}
        disabled={disabled}
        id="radio-aligned-no"
        label={intl.formatMessage({
          defaultMessage: 'No',
          id: 'bafd7',
        })}
        onChange={updateStatus}
        size="regular"
        value={MISALIGNED_RADIO_BUTTON_VALUE}
      />
    </RadioGroup>
  );
}

export default { AlignmentVerificationSelection };
